import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-5 text-center">
      <Logo />
      <div className="mt-12 max-w-md">
        <h1 className="font-mont text-3xl font-bold text-bone sm:text-4xl" data-testid="payment-cancel-title">
          No charge — checkout cancelled.
        </h1>
        <p className="mt-4 font-mont text-sm leading-relaxed text-white/60">
          Whenever you&rsquo;re ready, your spot is waiting. The founding rate
          holds for the first 6 seats.
        </p>
        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <button
            data-testid="payment-retry-button"
            onClick={() => navigate("/")}
            className="w-full bg-forest px-9 py-4 font-mont text-[12px] font-bold uppercase tracking-[0.22em] text-white transition-colors duration-300 hover:bg-[#2a6b50] sm:w-auto"
          >
            Try again
          </button>
          <button
            data-testid="payment-back-button"
            onClick={() => navigate("/")}
            className="w-full border border-white/25 px-9 py-4 font-mont text-[12px] font-bold uppercase tracking-[0.22em] text-bone transition-colors duration-300 hover:bg-white/5 sm:w-auto"
          >
            Back to the site
          </button>
        </div>
      </div>
    </div>
  );
}
